import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Row, Col, message, DatePicker, Checkbox, Upload, Typography, Spin } from "antd";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../../pageHeader/LeftLayout";
import _consumerService from "../../../modules/consumerService";
import { APPLICATION_SUBMIT_SUCCESSFULLY, SUBMISSION_FAILED, FILE_SIZE_VALIDATION, FILE_TYPE_VALIDATION, COMMON_ERROR_MSG } from "../../../constants/constants";
import { routes } from "../../../routes/Routes";
import CurrencyInput from "../../../components/CurrencyInput";
import ConsumerApplicationProgressBar from "../Consumer/ConsumerApplicationProgressBar";
import ConsumerShowApplicationId from "../Consumer/ConsumerShowApplicationId";
import IntegerInput from "../../../components/IntergerInput";


const { Option } = Select;
const { Title, Text } = Typography;

const normalizeNumber = (val) => {
    if (!val) return "";
    return val
        .toString()
        .replace(/,/g, "")
        .replace(/[^0-9.-]/g, "");
};

const IncomeSourcesForConsumer = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [form] = Form.useForm();
    const [fileList, setFileList] = useState([]);
    const [IncomeSource, setIncomeSource] = useState({});
    const applicationId = localStorage.getItem("ApplicationId");


    const location = useLocation();
    let locData = location.state;
    let applnObjId = "";
    let activeKeyTab = null;
    let fromDashboard = false;
    let selectedApplicationFlow = null;

    if (locData && locData.applicationObjId) {
        applnObjId = locData.applicationObjId;
    }

    if (locData && locData.isFromDashboard) {
        fromDashboard = locData.isFromDashboard;
    }
    if (locData && locData.activeKey) {
        activeKeyTab = locData.activeKey;
    }
    if (locData && locData.selectedDocumentOption) {
        selectedApplicationFlow = locData.selectedDocumentOption;
    }

    const [appObjId] = useState(applnObjId);
    const [isFromDashboard] = useState(fromDashboard);
    const [tabActiveKey] = useState(activeKeyTab);
    const [selectedApplicationDocFlow] = useState(selectedApplicationFlow);

    useEffect(() => {
        if (!locData || (typeof locData === "object" && Object.keys(locData).length === 0)) {
            history.push({ pathname: routes.consumerDashboard.path });
            return;
        }

        GetIncomeSourceByApplicationID();
    }, []);

    useEffect(() => form.resetFields(), [IncomeSource]);

    // 🧠 Watch each income field separately
    const watchSalary = Form.useWatch("salaryGross", form);
    const watchBonus = Form.useWatch("bonusAndCommissions", form);
    const watchDividends = Form.useWatch("dividends", form);
    const watchInterest = Form.useWatch("interest", form);
    const watchRental = Form.useWatch("rentalIncome", form);
    const watchPartnership = Form.useWatch("generalLimitedPratnershipIncome", form);
    const watchTrust = Form.useWatch("trustIncome", form);
    const watchPension = Form.useWatch("pensionIncome", form);
    const watchOther = Form.useWatch("otherIncome", form);

    // 🧮 Auto-calculate total
    useEffect(() => {
        const toNumber = (val) => {
            const num = parseFloat(val);
            return isNaN(num) ? 0 : num;
        };

        const total =
            toNumber(watchSalary) +
            toNumber(watchBonus) +
            toNumber(watchDividends) +
            toNumber(watchInterest) +
            toNumber(watchRental) +
            toNumber(watchPartnership) +
            toNumber(watchTrust) +
            toNumber(watchPension) +
            toNumber(watchOther);

        form.setFieldsValue({ total: total.toFixed(2) });
        console.log("watchSalary", toNumber(watchSalary));
        console.log("watchBonus", toNumber(watchBonus));
        console.log("watchDividends", toNumber(watchDividends));
        console.log("watchInterest", toNumber(watchInterest));
        console.log("watchRental", toNumber(watchRental));
        console.log("watchPartnership", toNumber(watchPartnership));
        console.log("watchTrust", toNumber(watchTrust));
        console.log("watchPension", toNumber(watchPension));
        console.log("watchOther", toNumber(watchOther));
        console.log("total", total);
    }, [
        watchSalary,
        watchBonus,
        watchDividends,
        watchInterest,
        watchRental,
        watchPartnership,
        watchTrust,
        watchPension,
        watchOther,
        form,
    ]);



    const onFinish = async (values) => {

        if (values && parseFloat(values.total) <= 0) {
            message.error("Please enter an amount in at least one field (Total Income should not be 0)");
            return false;
        }

        setLoading(true);

        const reqObj = {
            ApplicationId: localStorage.getItem("ApplicationObjId"),
            IsIncomesourceCompleted: true,
            CBRScore: values.creditBureauScore,
            listincomesource: [
                {
                    Id: 1,
                    ApplicationId: localStorage.getItem("ApplicationObjId"),
                    GrossSalary: values.salaryGross,
                    BonusCommission: values.bonusAndCommissions,
                    Devidend: values.dividends,
                    Interest: values.interest,
                    RentalIncome: values.rentalIncome,
                    GenLimitedPartnershipIncome: values.generalLimitedPratnershipIncome,
                    TrustIncome: values.trustIncome,
                    PensionIncome: values.pensionIncome,
                    OtherIncome: values.otherIncome,
                    IncomeSourceTotal: values.total,
                }
            ]
        };
        try {
            const res = await _consumerService.AddOrUpdateIncomeSource(reqObj);
            //  debugger
            if (res.data.IsSuccess) {
                //  debugger
                setLoading(false);
                message.success(res.data.Message);
                // if (isFromDashboard) {
                //     history.push({ pathname: routes.consumerDetailsDashboard.path, state: { appObjId, activeKey: tabActiveKey } });
                // }
                // else {
                //     history.push(routes.consumerDetailsDashboard.path);
                // }

                 if (selectedApplicationDocFlow) {
                    history.push({ pathname: routes.expensesForConsumer.path, state: { appObjId, activeKey: tabActiveKey, selectedDocumentOption: selectedApplicationDocFlow } });
                }
                else {
                  history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });
                }

                //history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });

            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            message.error(err.message || SUBMISSION_FAILED);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    let Id = localStorage.getItem("ApplicationObjId");

    const GetIncomeSourceByApplicationID = async () => {
        try {
            setLoading(true);
            const res = await _consumerService.getIncomeSourceByApplicationID(localStorage.getItem("ApplicationObjId"));
            // debugger

            if (res.data && res.data.length > 0) {
                const item = res.data[0];
                const mappedItem = {
                    salaryGross: normalizeNumber(item.GrossSalary),
                    bonusAndCommissions: normalizeNumber(item.BonusCommission),
                    dividends: normalizeNumber(item.Devidend),
                    interest: normalizeNumber(item.Interest),
                    rentalIncome: normalizeNumber(item.RentalIncome),
                    generalLimitedPratnershipIncome: normalizeNumber(item.GenLimitedPartnershipIncome),
                    trustIncome: normalizeNumber(item.TrustIncome),
                    pensionIncome: normalizeNumber(item.PensionIncome),
                    otherIncome: normalizeNumber(item.OtherIncome),
                    total: normalizeNumber(item.IncomeSourceTotal),
                    Application_Status_Id: item.Application_Status_Id,
                    creditBureauScore: item.CBRScore,
                };
                setIncomeSource(mappedItem);
                setLoading(false);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };

    const onBack = () => {
        // if (isFromDashboard) {
        //     history.push({ pathname: routes.consumerDetailsDashboard.path, state: { appObjId, activeKey: tabActiveKey } });
        // } else {
        //     history.push(routes.consumerDetailsDashboard.path);
        // }
        if (selectedApplicationDocFlow) {
            history.push({ pathname: routes.documentsUpload.path, state: { applicationObjId: appObjId, selectedDocumentOption: selectedApplicationDocFlow } });    
        } else {
            history.push({ pathname: routes.consumerDetailsDashboard.path, state: { activeKey: "4" } });
        }

    }

    return (
        <Spin spinning={loading}>
            <LeftLayout>
                {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
                    <div style={{
                        position: "absolute",
                        top: 5,
                        right: 20,
                        margin: 0,
                        zIndex: 1000,
                        maxWidth: "1000px",
                        padding: "8px 16px",
                        display: "none",
                    }}>
                        <ConsumerApplicationProgressBar />
                        <Title level={3} style={{ margin: 0 }}>
                            <ConsumerShowApplicationId />
                        </Title>
                    </div>
                )}
                <div className="profile-wrapper">
                    <div className="profile-card">
                    {/* <Col span={24}> */}
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3" }}> Income Sources </Title>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={IncomeSource}
                        className="inputBoxStyle"
                    >
                        <Row gutter={16} >
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Salary (Gross)"
                                    name="salaryGross"

                                    rules={[{ required: false, message: "Salary (Gross) is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Salary (Gross)" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Bonus and Commissions"
                                    name="bonusAndCommissions"

                                    rules={[{ required: false, message: "Bonus and Commissions is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Bonus and Commissions" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Dividends"
                                    name="dividends"

                                    rules={[{ required: false, message: "Dividends is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Dividends" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Interest"
                                    name="interest"

                                    rules={[{ required: false, message: "Interest is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Interest" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Rental Income (Net)"
                                    name="rentalIncome"

                                    rules={[{ required: false, message: "Rental Income (Net) is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Rental Income (Net)" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="General Limited Partnership Income (Net)"
                                    name="generalLimitedPratnershipIncome"

                                    rules={[{ required: false, message: "General Limited Partnership Income (Net) is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter General Limited Partnership Income (Net)" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Trust Income"
                                    name="trustIncome"

                                    rules={[{ required: false, message: "Trust Income is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Trust Income" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Pension Income"
                                    name="pensionIncome"

                                    rules={[{ required: false, message: "Pension Income is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Pension Income" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Other Income"
                                    name="otherIncome"

                                    rules={[{ required: false, message: "Other Income is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Other Income" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Form.Item
                                    label="Total"
                                    name="total"

                                    rules={[{ required: false, message: "Total is required" }]}
                                >
                                    <CurrencyInput placeholder="Enter Total" disabled />
                                </Form.Item>
                            </Col>
                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                    <Form.Item
                                        label=" CBR Score"
                                        name="creditBureauScore"
                                        rules={[
                                            { required: true, message: "CBR Score is required" },
                                            {
                                                validator: (_, value) => {
                                                    // ⛔ don't check empty here
                                                    if (!value) return Promise.resolve();

                                                    const num = Number(value);

                                                    if (!Number.isInteger(num)) {
                                                        return Promise.reject(new Error("Enter a valid integer"));
                                                    }

                                                    if (num < 500 || num > 900) {
                                                        return Promise.reject(
                                                            new Error("CBR Score must be between 500 and 900")
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            },
                                        ]}
                                    >
                                        <IntegerInput
                                            maxLength={3}
                                            placeholder="Enter CBR Score"

                                        />
                                    </Form.Item>
                                </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>

                                <Form.Item>
                                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }} >
                                        <Button
                                            onClick={onBack}
                                            icon={<LeftOutlined />}
                                        >
                                            Go Back
                                        </Button>
                                        <Button
                                            type="primary"
                                            htmlType="submit"
                                            // disabled={
                                            //     !(
                                            //         Object.keys(IncomeSource || {}).length === 0 ||
                                            //         [1, 6].includes(IncomeSource?.Application_Status_Id)
                                            //     )
                                            // }
                                            disabled={["1", "6"].includes(localStorage.getItem("ApplicationStatusId")) ? false : true}
                                        >
                                            Save And Proceed <RightOutlined />
                                        </Button>
                                    </div>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    {/* </Col> */}
                </div>
                </div>
            </LeftLayout>
        </Spin>
    );
};

export default IncomeSourcesForConsumer;